var _circle, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNameService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 22,
    stroke: "#c0a44d",
    strokeWidth: 2,
    fill: "none"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 31,
    textAnchor: "middle",
    fontSize: 26,
    fontWeight: "bold",
    fill: "#c0a44d",
    fontFamily: "Arial, sans-serif"
  }, "@")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameService);
export default __webpack_public_path__ + "static/media/name-service.29d4d1c30a0ced44aa093f7d78c41f2e.svg";
export { ForwardRef as ReactComponent };